import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Grid, Stack } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { MprcLink } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useSession } from "providers/SessionProvider";
import { useModalUserProfile } from "providers/UserProfileProvider";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { resolveAuthor } from "views/knowledge/components/card/behaviors/common/DefaultAuthor";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { CardContextLink } from "views/knowledge/components/card/CardContextLink";

///
export const ContentPageAuthor = () => {
    const { pub } = useCardContext();
    const { t } = useTranslation("knowledge");
    const navigate = useNavigate();
    const location = useLocation();
    const { showUser } = useModalUserProfile();
    const session = useSession();

    var author = resolveAuthor(pub, t, session.user.userId);

    const RenderAuthorName = (
        <MprcFeedTypography variant="authorPrimary" component="div" noWrap>
            <span title={author.name}>{author.name}</span>
            {
                pub.supervisor != null &&
                <span> ({t("Feed.Card.Common.EditedBySupervisorText")})</span>
            }
        </MprcFeedTypography>
    );

    return (
        <>
            <Grid container justifyContent="center" alignItems="center" spacing={1} width="100%">
                {!pub.isAnonymous &&
                    <Grid>
                        {pub.institutional != null
                            ? <Avatar src={author.thumbnailUrl} title={author.name} />
                            : <Avatar
                                className={AppGlobalClassKeys.clickable}
                                title={author.name}
                                src={author.thumbnailUrl}
                                onClick={
                                    () => showUser(
                                        pub.author.userId,
                                        () => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: pub.publicationId } })
                                    )
                                }
                            />
                        }
                    </Grid>
                }
                <Grid size="grow" overflow="hidden">
                    <Stack direction="row" alignItems="center" gap={0.5}>
                        {
                            (pub.institutional != null || pub.isAnonymous)
                                ? RenderAuthorName
                                : (
                                    <MprcLink
                                        width="100%"
                                        onClick={
                                            () => showUser(
                                                pub.author.userId,
                                                () => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: pub.publicationId } })
                                            )
                                        }
                                    >
                                        {RenderAuthorName}
                                    </MprcLink>
                                )
                        }
                    </Stack>
                    <MprcFeedTypography variant="authorSecondary" component="div" noWrap>
                        <span>{author.actionFormatted}</span>
                        {
                            !pub.isDraft && pub.channel?.name &&
                            <>
                                <span>&nbsp;{t("shared:Literal.At")}&nbsp;</span>
                                <CardContextLink
                                    publicationId={pub.publicationId}
                                    to={KnowledgePaths.FeedChannel(pub.channel.id)}
                                >
                                    <b>{pub.channel.name}</b>
                                </CardContextLink>
                            </>
                        }
                        {pub.isPrivate &&
                            <MprcFeedTypography variant="authorPrimary" component="span" ml={1}>
                                <FontAwesomeIcon icon={faLock} title={t("Feed.Card.Common.PrivateTooltip")} />
                            </MprcFeedTypography>
                        }
                    </MprcFeedTypography>
                </Grid>
            </Grid>
        </>
    );
};
